import React from 'react';

import messages from '../reportingMessages';

import DataCacheService from '@/shared/services/DataCacheService';
import { Dropdown, MenuItem, SplitButton } from 'react-bootstrap';
import { FaCouch, FaGraduationCap, FaPlus, FaSun } from 'react-icons/fa';
import DropdownMenu from 'react-bootstrap/lib/DropdownMenu';
import { FormattedMessage } from 'react-intl';
import AuthService, { features, functionalities, privileges } from '@/shared/services/AuthService';

const AddRegistrationDropdownButton = ({ onAddRegistration, intl, userId }) => {
  const showRecup = DataCacheService.timeTablesEnabled();
  const otherUserName =
    !!userId &&
    userId !== AuthService.getUserId() &&
    AuthService.hasPermission({
      functionality: functionalities.RegistrationOthers,
      privilege: privileges.Create,
    })
      ? DataCacheService.getUserName(userId)
      : null;
  const showTraining = AuthService.hasFeature(features.Training);
  const otherUserValues = { user: otherUserName };
  return (
    <SplitButton
      onClick={() => onAddRegistration({ type: 0 })}
      id="AddRegistrationButton"
      bsStyle="inverse"
      pullRight
      toggleLabel={intl.formatMessage(messages.AddAbsence)}
      title={
        <span>
          <FaPlus className="react-icon" />
          <FormattedMessage {...messages.AddRegistration} />
        </span>
      }
    >
      <MenuItem eventKey="1" onSelect={() => onAddRegistration({ type: 3 })}>
        <FaSun className="react-icon fa-fw margin5R" />
        <FormattedMessage {...messages.AddAbsence} />
      </MenuItem>
      {showRecup ? (
        <MenuItem eventKey="2" onSelect={() => onAddRegistration({ type: 4 })}>
          <FaCouch className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.AddRecuperation} />
        </MenuItem>
      ) : null}
      {showTraining ? (
        <MenuItem eventKey="3" onSelect={() => onAddRegistration({ type: 5 })}>
          <FaGraduationCap className="react-icon fa-fw margin5R" />
          <FormattedMessage {...messages.AddTraining} />
        </MenuItem>
      ) : null}
      {otherUserName ? (
        <>
          <MenuItem divider />
          <MenuItem eventKey="4" onSelect={() => onAddRegistration({ type: 0, userId })}>
            <FaPlus className="react-icon fa-fw margin5R" />
            <FormattedMessage {...messages.AddRegistrationFor} values={otherUserValues} />
          </MenuItem>
          <MenuItem eventKey="5" onSelect={() => onAddRegistration({ type: 3, userId })}>
            <FaSun className="react-icon fa-fw margin5R" />
            <FormattedMessage {...messages.AddAbsenceFor} values={otherUserValues} />
          </MenuItem>
          {showRecup ? (
            <MenuItem eventKey="6" onSelect={() => onAddRegistration({ type: 4, userId })}>
              <FaCouch className="react-icon fa-fw margin5R" />
              <FormattedMessage {...messages.AddRecuperationFor} values={otherUserValues} />
            </MenuItem>
          ) : null}
          {showTraining ? (
            <MenuItem eventKey="7" onSelect={() => onAddRegistration({ type: 5, userId })}>
              <FaGraduationCap className="react-icon fa-fw margin5R" />
              <FormattedMessage {...messages.AddTrainingFor} values={otherUserValues} />
            </MenuItem>
          ) : null}
        </>
      ) : null}
    </SplitButton>
  );
};
export default AddRegistrationDropdownButton;
